import { Tab, Tabs } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../../auth/AuthContext";
import { Permission } from "../../../auth/permissions";
import { hasPermission } from "../../../auth/rolePermissions";

export type StaffKind = "faculty" | "staff";

/**
 * Which kind the Staff pages show, kept in the URL (?type=faculty|staff) so refresh / back keep it.
 * Faculty is the default, unless the user can't manage faculty.
 */
export const useStaffKind = (): [StaffKind, (kind: StaffKind) => void, boolean] => {
  const { user } = useAuth();
  const canManageFaculty = hasPermission(user?.role, Permission.FACULTY_MANAGE);
  const [params, setParams] = useSearchParams();
  const requested = params.get("type");
  const kind: StaffKind = !canManageFaculty || requested === "staff" ? "staff" : "faculty";
  const setKind = (next: StaffKind) => setParams({ type: next }, { replace: true });
  return [kind, setKind, canManageFaculty];
};

/** Faculty | Staff tabs at the top left of the Staff pages. */
export const StaffTypeToggle = ({ kind, onChange }: { kind: StaffKind; onChange: (kind: StaffKind) => void }) => (
  <Tabs value={kind} onChange={(_, next: StaffKind) => onChange(next)} sx={{ minHeight: 40 }}>
    <Tab value="faculty" label="Faculty" sx={{ minHeight: 40, textTransform: "none", fontWeight: 600 }} />
    <Tab value="staff" label="Staff" sx={{ minHeight: 40, textTransform: "none", fontWeight: 600 }} />
  </Tabs>
);
